import React, { useState } from "react"
import { Badge, Button, Image } from "antd"
import NotificationsDrawer from "./NotificationsDrawer"

export const Notifications = () => {
    
    const [visible, setVisible]= useState(false)
    return (
        <>
            <Badge count={9} overflowCount={9}>
                <Button className='bg-transparent border0 p-0' onClick={()=> setVisible(true)}>
                    <Image 
                        src='/assets/icons/notification.png' 
                        width={'28px'} 
                        preview={false}
                        alt="tagdev" 
                        className="up"
                    />
                </Button>
            </Badge>
            <NotificationsDrawer
                visible={visible}
                onClose={()=> setVisible(false)}
            />
        </>
    )
}